import { render } from "./FlipAsIsView.vue?vue&type=template&id=213d52cf&ts=true"
import script from "./FlipAsIsView.vue?vue&type=script&lang=ts"
export * from "./FlipAsIsView.vue?vue&type=script&lang=ts"

import "./FlipAsIsView.vue?vue&type=style&index=0&id=213d52cf&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__